const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const SEPERATOR = require('../../utils/constants');
const Base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getBpData(inputParam, metaData) {
      const url = getUrl('business-partners/fetch');
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const userId = params[0];
      const decodedUserId = Base64.decode(userId);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };

      const body = {
        userId: decodedUserId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },

    getContactDetailsListData(inputParam, metaData) {
      const url = getUrl('contacts/fetch');
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const userId = params[0];
      const bpId = params[1];
      const decodedUserId = Base64.decode(userId);
      const decodedBpId = Base64.decode(bpId);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      const body = {
        userId: decodedUserId,
        bpId: decodedBpId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));


    },

    saveForm(inputParam, metaData) {
      const url = getUrl('hrmw-options/accept');
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);

      const userId = params[0];
      const bpId = params[1];
      const reqParams = params[2];
      const decodedUserId = Base64.decode(userId);
      const decodedBpId = Base64.decode(bpId);
      const decodedReqParams = Base64.decode(reqParams);
      const options = [];
      const proposals = [];
      const parsedArgs = JSON.parse(decodedReqParams);
      options.push(parsedArgs);
      proposals.push({ options: options[0] });
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      const body = {
        userId: decodedUserId,
        bpId: decodedBpId,
        proposals: proposals
      }
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },
    
    saveContactDetails(inputParam, metaData) {
      const url = getUrl('contacts/save');
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);

      const userId = params[0];
      const bpId = params[1];
      const reqParams = params[2];
      const isPaperlessStatus = params[3] ? params[3]: null;
      const decodedUserId = Base64.decode(userId);
      const decodedBpId = Base64.decode(bpId);
      const decodedReqParams = Base64.decode(reqParams);
      const parsedArgs = JSON.parse(decodedReqParams);
      const reqOpts = { 
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      const body = {
        userId: decodedUserId,
        bpId: decodedBpId,
        contacts: parsedArgs,
        paperlessOptinStatus: isPaperlessStatus ? Base64.decode(isPaperlessStatus) : null
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },

    signContact(inputParam, metaData) {
      const url = getUrl('contacts/sign');
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      
      const bpId = params[0];
      const deviceCode = params[1];
      const otp = params[2];
      const channel = params[3];
      const decodedBpId = Base64.decode(bpId);
      const decodedOtp = Base64.decode(otp);
  
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      
      const body = {
        channel,
        userId: parsedMetaData.qs.userId,
        deviceCode,
        oneTimePassword: decodedOtp,
        bpId: decodedBpId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },
  }
}
module.exports = apiFactory;